/** Definições de parâmetros de assert — enums viram opções selecionáveis. */

export const INTENT_OPTIONS = [
    { value: "loja", label: "Loja" },
    { value: "grading", label: "Grading" },
    { value: "leilao", label: "Leilão" },
    { value: "outro", label: "Outro" },
];

export const CW_STATUS_OPTIONS = [
    { value: "open", label: "Aberta (open)" },
    { value: "pending", label: "Pendente" },
    { value: "resolved", label: "Resolvida" },
    { value: "snoozed", label: "Adiada" },
];

export const ASSIGNEE_OPTIONS = [
    { value: "true", label: "Presente (humano)" },
    { value: "false", label: "Ausente (bot)" },
];

export const ASSERT_PARAM_FIELDS = {
    assertIntentEquals: [
        {
            key: "expectedIntent",
            label: "Intent esperado",
            type: "enum",
            required: true,
            options: INTENT_OPTIONS,
            help: "Assunto que o bot deve classificar neste turno (schema do turno).",
        },
    ],
    assertCwStatus: [
        {
            key: "expectedStatus",
            label: "Status Chatwoot",
            type: "enum",
            required: true,
            options: CW_STATUS_OPTIONS,
            help: "Status da conversa após o turno.",
        },
    ],
    assertCwAssignee: [
        {
            key: "expectAssignee",
            label: "Assignee",
            type: "enum",
            required: true,
            options: ASSIGNEE_OPTIONS,
            encode: (uiValue) => uiValue === "false" ? false : true,
            decode: (stored) => (stored === false ? "false" : "true"),
            help: "Presente = conversa com atendente; Ausente = ainda com o bot.",
        },
    ],
    assertCwAttr: [
        {
            key: "attrKey",
            label: "Chave do atributo",
            type: "text",
            required: true,
            placeholder: "ex.: intent",
            help: "Nome do custom_attribute no Chatwoot.",
        },
        {
            key: "attrValue",
            label: "Valor do atributo",
            type: "text",
            required: true,
            placeholder: "ex.: grading",
            help: "Valor esperado desse atributo.",
        },
    ],
};

export function fieldsForAssertIds(assertIds = []) {
    const out = [];
    for (const assertId of assertIds) {
        const config = ASSERT_PARAM_FIELDS[assertId];
        if (!config) continue;
        for (const field of config) {
            out.push({ assertId, ...field });
        }
    }
    return out;
}

export function readParamUiValue(field, assertParams = {}) {
    const raw = assertParams[field.key];
    if (typeof field.decode === "function") {
        return field.decode(raw);
    }
    if (raw == null) return "";
    return String(raw);
}

export function writeParamValue(field, uiValue) {
    if (uiValue === "" || uiValue == null) {
        return undefined; // caller deletes key
    }
    if (typeof field.encode === "function") {
        return field.encode(uiValue);
    }
    return uiValue;
}
